import React, { useState } from 'react';
import walletService from '../../services/walletService';

export default function TransferModal({ isOpen, onClose }) {
  const [fromWallet, setFromWallet] = useState('spot');
  const [toWallet, setToWallet] = useState('futures');
  const [amount, setAmount] = useState('');
  const [asset, setAsset] = useState('USDT');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  React.useEffect(() => {
    if (isOpen) {
      setAmount('');
      setError('');
      setSuccess('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleTransfer = async () => {
    if (!amount || amount <= 0) {
      setError('Veuillez entrer un montant valide');
      return;
    }
    if (fromWallet === toWallet) {
      setError('Les portefeuilles source et destination doivent être différents');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');
      
      await walletService.transferFunds({
        asset,
        from_wallet: fromWallet,
        to_wallet: toWallet,
        amount: parseFloat(amount)
      });
      
      setSuccess('Transfert effectué avec succès !');
      setAmount('');
      setTimeout(() => {
        onClose();
        window.location.reload(); // Refresh to update balances
      }, 2000);
      
    } catch (e) {
      setError(e.message || 'Erreur lors du transfert');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16, zIndex: 9999, backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        background: '#0f172a', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 16, width: '100%', maxWidth: 400,
        boxShadow: '0 25px 50px rgba(0,0,0,0.5)', padding: 24
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ color: '#f1f5f9', margin: 0, fontSize: 18, fontWeight: 700 }}>🔄 Transfert Interne</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>

        {error && <div style={{ background: 'rgba(239,68,68,0.1)', color: '#fca5a5', padding: 12, borderRadius: 8, marginBottom: 16, fontSize: 14 }}>⚠️ {error}</div>}
        {success && <div style={{ background: 'rgba(16,185,129,0.1)', color: '#34d399', padding: 12, borderRadius: 8, marginBottom: 16, fontSize: 14 }}>✅ {success}</div>}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 6 }}>De (Source)</label>
          <select 
            value={fromWallet} onChange={(e) => setFromWallet(e.target.value)}
            style={{ width: '100%', background: '#1e293b', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px', color: '#e2e8f0', outline: 'none' }}
          >
            <option value="spot">Portefeuille Spot</option>
            <option value="futures">Portefeuille Futures</option>
            <option value="investment">Portefeuille Investissement</option>
          </select>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 6 }}>Vers (Destination)</label>
          <select 
            value={toWallet} onChange={(e) => setToWallet(e.target.value)}
            style={{ width: '100%', background: '#1e293b', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px', color: '#e2e8f0', outline: 'none' }}
          >
            <option value="spot">Portefeuille Spot</option>
            <option value="futures">Portefeuille Futures</option>
            <option value="investment">Portefeuille Investissement</option>
          </select>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 6 }}>Actif</label>
          <select 
            value={asset} onChange={(e) => setAsset(e.target.value)}
            style={{ width: '100%', background: '#1e293b', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px', color: '#e2e8f0', outline: 'none' }}
          >
            <option value="USDT">USDT</option>
            <option value="BTC">BTC</option>
            <option value="ETH">ETH</option>
          </select>
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 6 }}>Montant</label>
          <input 
            type="number" value={amount} onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            style={{ width: '100%', background: '#1e293b', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px', color: '#e2e8f0', outline: 'none', boxSizing: 'border-box' }}
          />
        </div>

        <button 
          onClick={handleTransfer} disabled={loading}
          style={{ width: '100%', background: '#6366f1', color: 'white', border: 'none', padding: '12px', borderRadius: 8, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
        >
          {loading ? 'Traitement...' : 'Transférer'}
        </button>
      </div>
    </div>
  );
}
